import React from 'react';

import NavbarUser from './NavbarUser';

/**
 * Copyright (c) Fing Ltd. All rights reserved.
 *
 * @author Tommaso Latini <tommaso@fing.com>
 */
export default class NavbarBody extends React.Component {

    render() {
        const { id = 'menu', full = false, className = '', children } = this.props;
        return [
            <button key={`toggle_${id}`} type="button" className="navbar-toggler btn btn-icon btn-sm rounded-circle"
                    aria-label="Toggle navigation" aria-expanded="false" aria-controls={id} data-toggle="collapse" data-target={`#${id}`}>
                <span className="navbar-toggler-default">
                    <svg width="14" height="14" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                        <path fill="currentColor" d="M17.4,6.2H0.6C0.3,6.2,0,5.9,0,5.5V4.1c0-0.4,0.3-0.7,0.6-0.7h16.9c0.3,0,0.6,0.3,0.6,0.7v1.4C18,5.9,17.7,6.2,17.4,6.2z M17.4,14.1H0.6c-0.3,0-0.6-0.3-0.6-0.7V12c0-0.4,0.3-0.7,0.6-0.7h16.9c0.3,0,0.6,0.3,0.6,0.7v1.4C18,13.7,17.7,14.1,17.4,14.1z"></path>
                    </svg>
                </span>
                <span className="navbar-toggler-toggled">
                    <svg width="14" height="14" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                        <path fill="currentColor" d="M11.5,9.5l5-5c0.2-0.2,0.2-0.6-0.1-0.9l-1-1c-0.3-0.3-0.7-0.3-0.9-0.1l-5,5l-5-5C4.3,2.3,3.9,2.4,3.6,2.6l-1,1 C2.4,3.9,2.3,4.3,2.5,4.5l5,5l-5,5c-0.2,0.2-0.2,0.6,0.1,0.9l1,1c0.3,0.3,0.7,0.3,0.9,0.1l5-5l5,5c0.2,0.2,0.6,0.2,0.9-0.1l1-1 c0.3-0.3,0.3-0.7,0.1-0.9L11.5,9.5z"></path>
                    </svg>
                </span>
            </button>,
            <div id={id} key={id} className="collapse navbar-collapse">
                <div className="navbar-body ml-auto">
                    <div className="navbar-nav nav-list-y-2 m-0 p-0">
                        <ul className={className}>
                            {children}
                        </ul>
                        <NavbarUser full={!!full} />
                    </div>
                </div>
            </div>
        ];
    }
};